<script setup lang="ts">
/**
 * Floating "+" quick-add button (E14).
 *
 * Fixed bottom-right across the whole app. Visible only to users who can
 * actually create content (analyst/admin/super_admin). Click opens the
 * picker — same entry point as the 'n' keyboard shortcut.
 *
 * The visual design is intentionally subtle — a small pill button rather
 * than a massive material-style FAB. Users who know the shortcut won't
 * need this; it's a discoverability affordance for everyone else.
 */
import { computed } from 'vue';
import { Plus } from 'lucide-vue-next';
import { useQuickAddStore } from '@/stores/quickAddStore';
import { useAuthStore } from '@/stores/authStore';

const qa = useQuickAddStore();
const auth = useAuthStore();

const canCreate = computed(() => {
  const role = auth.user?.role;
  return role === 'analyst' || role === 'admin' || role === 'super_admin';
});
</script>

<template>
  <button
    v-if="canCreate"
    class="quick-add-fab fixed bottom-6 right-6 z-40 flex items-center gap-2 px-4 py-2.5 rounded-full bg-accent-blue text-white text-sm font-medium shadow-lg hover:opacity-90 cwr-motion"
    title="Quick add (n)"
    data-qa-fab
    @click="qa.openPicker"
  >
    <Plus class="w-4 h-4" />
    <span>Quick add</span>
    <kbd class="quick-add-fab-shortcut bg-white/20 rounded px-1 py-0.5 text-[10px] font-mono">n</kbd>
  </button>
</template>
